// extracted by mini-css-extract-plugin
export default {"Link":"LpNluKjS2jxpGaygak1e"};